import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { type StratumSummary } from "./eval-config";

/**
 * Per-stratum census for a selection preview or a frozen set. Renders only the
 * axis columns that are actually populated across the strata, so an unstratified
 * set collapses to a single total row rather than a table of empty cells.
 */
const StrataTable = ({ strata }: { readonly strata: StratumSummary[] }) => {
  if (strata.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No strata to show.
      </Typography>
    );
  }

  const showCompany = strata.some((s) => s.stratum.company !== undefined);
  const showDocType = strata.some((s) => s.stratum.documentType !== undefined);
  const showTier = strata.some((s) => s.stratum.approvalTier !== undefined);
  const showNovelty = strata.some((s) => s.stratum.novelty !== undefined);

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {showCompany && <TableCell>Company</TableCell>}
          {showDocType && <TableCell>Document type</TableCell>}
          {showTier && <TableCell>Approval tier</TableCell>}
          {showNovelty && <TableCell>Novelty</TableCell>}
          <TableCell align="right">Candidates</TableCell>
          <TableCell align="right">Selected</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {strata.map((s) => (
          <TableRow
            key={[
              s.stratum.company,
              s.stratum.documentType,
              s.stratum.approvalTier,
              s.stratum.novelty,
            ].join("|")}
          >
            {showCompany && <TableCell>{s.stratum.company ?? "—"}</TableCell>}
            {showDocType && (
              <TableCell>{s.stratum.documentType ?? "—"}</TableCell>
            )}
            {showTier && <TableCell>{s.stratum.approvalTier ?? "—"}</TableCell>}
            {showNovelty && <TableCell>{s.stratum.novelty ?? "—"}</TableCell>}
            <TableCell align="right">{s.candidateCount}</TableCell>
            <TableCell align="right">{s.selectedCount}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default StrataTable;
